export function minimizeObjects(obj: any, depth = 0) {
	if (Array.isArray(obj)) {
		// If the array has more than 5 elements, slice it to keep only the first 5 elements
		if (obj.length > 5) {
			obj = obj.slice(0, 5);
		}
		// Recursively call limitArrays for each element in the array
		obj.forEach((item: any, index: number) => {
			obj[index] = minimizeObjects(item, depth + 1);
		});
	} else if (typeof obj === 'object' && obj !== null) {
		// If the element is an object, recursively call limitArrays for each property value
		Object.keys(obj).forEach(key => {
			obj[key] = minimizeObjects(obj[key], depth + 1);
		});
	}
	// Return the modified object
	return obj;
}
